angular.module('aprima-core-ui').directive('scrollTo', ['$parse', 'ScrollerService', '$window', function ($parse, ScrollerService, $window) {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var parsedAttr = $parse(attr.scrollTo);
            scope.$evalAsync(function(){
                if(parsedAttr(scope)){
                    var scroller = ScrollerService.getScroller(attr.scrollerId) || $window;
                    scroller.scrollTo(0, element[0].offsetTop);
                }
            });
        }
    };
}]);